import { IsIos } from './is-ios';

export const CopyToClipboard = (text: string) => {
  const textArea = <HTMLTextAreaElement>document.createElement('textArea');
  textArea.value = text;
  document.body.appendChild(textArea);

  if (IsIos()) {
    const range = document.createRange();
    range.selectNodeContents(textArea);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    textArea.setSelectionRange(0, 999999);
  } else {
    textArea.select();
  }

  document.execCommand('copy');
  document.body.removeChild(textArea);
};
